// API URL
export const BASE_URL = process.env.REACT_APP_API_URL
export const BASE_URL_V2_1 = process.env.REACT_APP_API_URL_V2_1
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL

// 外部サービス
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY

// 利用規約
export const TERM_OF_USE_1 = process.env.REACT_APP_TERM_OF_USE_1
export const TERM_OF_USE_2 = process.env.REACT_APP_TERM_OF_USE_2

// 機能フラグ
export const SHOW_CSV_UPLOAD = process.env.REACT_APP_SHOW_CSV_UPLOAD

// お知らせ
export const NOTICE_REVISION_TXT_URL = `${process.env.REACT_APP_NOTICE_URL}notice-revision.txt`
export const NOTICES_JSON_URL = `${process.env.REACT_APP_NOTICE_URL}notices.json`
